module.exports = __webpack_public_path__ + "img/xiaomishu.64c96826.png";